import {
    CLICK_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT_BUTTON,
    CLOSE_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT,
    VIEW_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT
} from '../actionTypes/customerRiskAndCoverageActionTypes';

export const customerRiskAndCoverageSlideOutButton = () => ({
    type: CLICK_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT_BUTTON
});

export const viewCustomerRiskAndCoverageSlideOut = () => ({
    type: VIEW_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT
});

export const closeCustomerRiskAndCoverageSlideOut = () => ({
    type: CLOSE_CUSTOMER_RISK_AND_COVERAGE_SLIDEOUT
});
